<template>
  <v-dialog v-model="dialog" width="350px">
    <v-card>
      <v-card-title class="grey lighten-2">
        {{ dialogTitle }}
      </v-card-title>
      <v-card-text>
        <template v-if="numberOfIngredients === 1">
          <v-radio-group v-model="selectedIngredients">
            <v-radio
              v-for="(item, index) in ingredientItems"
              v-show="item.item !== ''"
              :key="index"
              :label="checkBoxLabel(item)"
              :value="item.item"
              class="mt-3"
            >
            </v-radio>
          </v-radio-group>
        </template>

        <template v-if="numberOfIngredients > 1">
          <div v-for="(item, index) in ingredientItems" :key="index">
            <v-row v-show="item.item !== ''">
              <v-col cols="8">
                <v-checkbox
                  hide-details
                  class="mt-0"
                  :label="checkBoxLabel(item)"
                  :disabled="!item.checked && disabledCheckbox"
                  :value="item"
                  @change="selectIngredients()"
                  v-model="selectedMultipleIngredients"
                ></v-checkbox>
              </v-col>

              <v-col cols="4" class="text-right">
                <template v-if="item.checked">
                  <button
                    style="position: relative;top:3px;"
                    class="mr-2"
                    type="button"
                    @click="downQty(item)"
                  >
                    <font-awesome-icon
                      icon="minus-square"
                      :style="{ color: '#ea2222', fontSize: 20 }"
                    />
                  </button>
                  <button
                    style="position: relative;top:3px;"
                    class="mr-2"
                    type="button"
                    @click="updateQty(item)"
                  >
                    <font-awesome-icon
                      icon="plus-square"
                      :style="{ color: '#11bd11', fontSize: 20 }"
                    />
                  </button>

                  <span class="cart-quantity">{{ item.quantity }}x</span>
                </template>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn text @click="dialog = false">{{ $t("common.close") }}</v-btn>
        <v-btn v-if="numberOfIngredients === 1" outlined @click="onDone">
          {{ $t("common.done") }}
        </v-btn>
        <v-btn
          v-if="numberOfIngredients > 1"
          :disabled="
            (selectedMultipleIngredients &&
              selectedMultipleIngredients.length === 0) ||
              totalSelectedQty > numberOfIngredients
          "
          outlined
          @click="onDoneMultiSelect"
          >{{ $t("common.done") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "IngredienteDialog",
  data() {
    return {
      product: null,
      ingredientItems: [],
      dialog: false,
      selectedIngredients: null,
      numberOfIngredients: 1,
      selectedMultipleIngredients: [],
      basePrice: 0
    };
  },
  computed: {
    disabledCheckbox() {
      return this.totalSelectedQty >= this.numberOfIngredients;
    },
    totalSelectedQty() {
      return this.selectedMultipleIngredients.reduce((a, b) => {
        return Number(a) + Number(b.quantity);
      }, 0);
    },
    dialogTitle() {
      let s = this.numberOfIngredients > 1 ? "s" : "";
      let es = this.numberOfIngredients > 1 ? "es" : "";

      return `Elige Ingrediente${s}/Sabor${es}`;
    }
  },
  watch: {
    dialog() {
      if (this.dialog === false) {
        this.ingredientItems = this.ingredientItems.map(item => {
          item.checked = false;
          item.quantity = 1;
          return item;
        });
        this.selectedMultipleIngredients = [];
      }
    }
  },
  methods: {
    checkBoxLabel(item) {
      let _item = this.translate("item", item);
      return `${_item +
        (item.add_price && item.add_price > 0
          ? " (+" + item.add_price + "€)"
          : "")}`;
    },
    open(product, ingredientItems, numberOfIngredients) {
      this.product = product;
      this.basePrice = product.price;
      this.selectedMultipleIngredients = [];
      this.ingredientItems = ingredientItems;
      this.numberOfIngredients = numberOfIngredients;

      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.items = null;

      this.ingredientItems = this.ingredientItems.map(item => {
        item.checked = false;
        return item;
      });
      this.selectedMultipleIngredients = [];
    },
    onDone() {
      if (this.selectedIngredients) {
        let self = this;

        this.product.orderActual = this.product.order;
        let selectedIngredientsValue = this.ingredientItems.find(item => {
          return (
            item.item.toLowerCase() === self.selectedIngredients.toLowerCase()
          );
        });

        self.product.order_translations = {
          en:
            self.translateToOneLang("name", self.product, "en") +
            ` ( ${this.translateToOneLang(
              "item",
              selectedIngredientsValue,
              "en"
            ) +
              " " +
              (selectedIngredientsValue.add_price &&
              selectedIngredientsValue.add_price > 0
                ? selectedIngredientsValue.add_price + "€"
                : "")})`,
          es:
            self.translateToOneLang("name", self.product, "es") +
            ` ( ${this.translateToOneLang(
              "item",
              selectedIngredientsValue,
              "es"
            ) +
              " " +
              (selectedIngredientsValue.add_price &&
              selectedIngredientsValue.add_price > 0
                ? selectedIngredientsValue.add_price + "€"
                : "")})`,
          fr:
            self.translateToOneLang("name", self.product, "fr") +
            ` ( ${this.translateToOneLang(
              "item",
              selectedIngredientsValue,
              "fr"
            ) +
              " " +
              (selectedIngredientsValue.add_price &&
              selectedIngredientsValue.add_price > 0
                ? selectedIngredientsValue.add_price + "€"
                : "")})`,
          de:
            self.translateToOneLang("name", self.product, "de") +
            ` ( ${this.translateToOneLang(
              "item",
              selectedIngredientsValue,
              "de"
            ) +
              " " +
              (selectedIngredientsValue.add_price &&
              selectedIngredientsValue.add_price > 0
                ? selectedIngredientsValue.add_price + "€"
                : "")})`,
          it:
            self.translateToOneLang("name", self.product, "it") +
            ` ( ${this.translateToOneLang(
              "item",
              selectedIngredientsValue,
              "it"
            ) +
              " " +
              (selectedIngredientsValue.add_price &&
              selectedIngredientsValue.add_price > 0
                ? selectedIngredientsValue.add_price + "€"
                : "")})`
        };

        let aditionalIngredientLabel = ` ( ${selectedIngredientsValue.item +
          " " +
          (selectedIngredientsValue.add_price &&
          selectedIngredientsValue.add_price > 0
            ? selectedIngredientsValue.add_price + "€"
            : "")})`;

        self.product.name = self.product.name + aditionalIngredientLabel;
        self.product.order = self.product.order + aditionalIngredientLabel;
        self.product.price =
          this.basePrice +
          selectedIngredientsValue.add_price *
            selectedIngredientsValue.quantity;

        console.log("PRODUCT", this.product);
        if (!this.product.isMenuGroupProduct) {
          console.log("ingredienteDialog");
          console.log("item", this.product);
          this.$store.commit("addToCart", { item: this.product, update: true });
          this.$store.dispatch("addStripeProductToCart", this.product);
          this.$forceUpdate(); // Force update to fetch cart data (for displaying the new quantity)
        } else {
          this.$store.commit("saveMenuGroupData", {
            item: this.product,
            update: true
          });
          this.$emit("setMenuGroupItem", this.product);
        }
        this.close();
      }
    },
    onDoneMultiSelect() {
      if (
        this.numberOfIngredients > 1 &&
        this.totalSelectedQty > this.numberOfIngredients
      ) {
        this.showErrorMessage(
          this.$t("modal.pleaseDecreaseTheQuantityOfProducts")
        );
        return;
      }

      if (this.selectedMultipleIngredients) {
        let self = this;

        this.product.orderActual = this.product.order;

        self.product.name =
          self.product.name +
          ` (${this.selectedMultipleIngredients.map(item => {
            return self.addPriceName(item);
          })})`;

        self.product.order =
          self.product.order +
          ` (${this.selectedMultipleIngredients.map(item => {
            return self.addPriceName(item);
          })})`;

        self.product.price =
          this.basePrice +
          this.totalIngredientsPrice(this.selectedMultipleIngredients);

        self.product.order_translations = {
          en:
            self.translateToOneLang("name", self.product, "en") +
            ` (${this.selectedMultipleIngredients.map(item => {
              return self.addPriceName(item, "en");
            })})`,
          es:
            self.translateToOneLang("name", self.product, "es") +
            ` (${this.selectedMultipleIngredients.map(item => {
              return self.addPriceName(item, "es");
            })})`,
          de:
            self.translateToOneLang("name", self.product, "de") +
            ` (${this.selectedMultipleIngredients.map(item => {
              return self.addPriceName(item, "de");
            })})`,
          it:
            self.translateToOneLang("name", self.product, "it") +
            ` (${this.selectedMultipleIngredients.map(item => {
              return self.addPriceName(item, "it");
            })})`,
          fr:
            self.translateToOneLang("name", self.product, "fr") +
            ` (${this.selectedMultipleIngredients.map(item => {
              return self.addPriceName(item, "fr");
            })})`
        };
        if (!this.product.isMenuGroupProduct) {
          this.$store.commit("addToCart", { item: this.product, update: true });
          this.$store.dispatch("addStripeProductToCart", this.product);
          this.$forceUpdate(); // Force update to fetch cart data (for displaying the new quantity)
        } else {
          this.$store.commit("saveMenuGroupData", {
            item: this.product,
            update: true
          });
          this.$emit("setMenuGroupItem", this.product);
        }
        this.close();
      }
    },
    addPriceName(item, lang = "") {
      if (!lang) {
        return `${item.quantity +
          " x " +
          item.item +
          " " +
          // eslint-disable-next-line no-prototype-builtins
          (item.hasOwnProperty("add_price") && item.add_price > 0
            ? item.add_price + "€"
            : "")}`;
      } else {
        return `${item.quantity +
          " x " +
          this.translateToOneLang("item", item, lang) +
          " " +
          // eslint-disable-next-line no-prototype-builtins
          (item.hasOwnProperty("add_price") && item.add_price > 0
            ? item.add_price + "€"
            : "")}`;
      }
    },
    downQty(item) {
      item.quantity = item.quantity - 1;
      if (item.quantity <= 1) {
        item.quantity = 1;
      }

      return item;
    },
    updateQty(item) {
      item.quantity = item.quantity + 1;
      return item;
    },
    selectIngredients() {
      this.ingredientItems = this.ingredientItems.map(item => {
        let found = this.selectedMultipleIngredients.some(ing => {
          if (JSON.stringify(ing) === JSON.stringify(item)) {
            return ing;
          }
        });

        if (found) {
          item.checked = true;
        } else {
          item.checked = false;
          item.quantity = 1;
        }
        return item;
      });
    },
    totalIngredientsPrice(arrayItem = []) {
      let total = 0;
      arrayItem.forEach(item => {
        let addPrice =
          item.add_price && item.add_price > 0
            ? item.quantity * item.add_price
            : 0;
        total = total + addPrice;
      });

      return total;
    }
  }
};
</script>

<style></style>
